export default {
  namespaced: true,

  state: () => ({
    loading: false,
    pendingRequests: 0,
  }),

  mutations: {
    START_LOADING(state) {
      state.pendingRequests++
      state.loading = true
    },

    STOP_LOADING(state) {
      state.pendingRequests--
      if (state.pendingRequests <= 0) {
        state.pendingRequests = 0
        state.loading = false
      }
    },
  },
}
